<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.closeCase.closeCase_title | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.closeCase.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  @if (!canClose) {
    <p class="body2 bottom-margin">{{ data.sysText.closeCase.canNotCloseMessage }}</p>
  }

  @if (canClose) {
    <p class="body2 bottom-margin">{{ data.sysText.closeCase.infoMessage }}</p>
    <p class="body2 bottom-margin">{{ data.sysText.closeCase.infoMessage2 }}</p>
    <form [formGroup]="form">
      <app-date-field
        [control]="this.form.controls.closeDate"
        [icon]="'today'"
        [label]="data.sysText.closeCase.datePickerCaption"
        (emitDateChange)="closeDateChangeHandler()">
      </app-date-field>
      <app-select-field
        [control]="this.form.controls.closeReasonId"
        [icon]="'help_center'"
        [label]="data.sysText.closeCase.closeReasonCaption"
        [options]="data.ccdata.closeReasons"
        (emitSelectionChange)="closeReasonChangeHandler()">
      </app-select-field>
      <app-text-area
        [control]="this.form.controls.comments"
        [label]="data.sysText.closeCase.closeCommentsCaption"
        [icon]="'comment'">
      </app-text-area>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!data.ccdata.isAnonymous && data.ccdata.showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.closeCase.closeCase_sendNotification">
      </app-slide-toggle>
    </div>
  }

  @let isSubmitting = isSubmitting$ | async;
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="cancel()">
        {{ data.sysText.closeCase.cancel }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.closeCase.submitting_ariaLabel : null"
      (click)="!isSubmitting && closeCase()">
      {{ data.sysText.closeCase.closeCase_button }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>